module.exports = __webpack_public_path__ + "img/tggl.c060aa4b.png";